module.exports = __webpack_public_path__ + "img/logo_haifn@2x.4c95c232.png";